module.exports = __webpack_public_path__ + "img/mortimer_b3.df2e1078.jpg";